<template>
  <div id="partnerships">
    <b-row>
      <b-col md="12">
        <div v-if="!loading">
          <h1>{{ num_programs }} partnerships {{ (search === '' || search === undefined) ? '' :  'for "' + search + '"' }}</h1>
        </div>
        <h1 v-if="loading">Loading...</h1>
      </b-col>
    </b-row>
    <br>
    <b-row id="partnership-filter">
      <b-col md="2">
        <b-form-group
          label="Order"
          label-for="order">
            <b-form-select
              id="order"
              :options="order_options"
              v-model="order">
            </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="U.S. States"
          label-for="us-state">
          <b-form-select
            id="us-state"
            :options="usStateProvinceOptions"
            text-field="name"
            value-field="name"
            v-model="usState">
              <template slot="first">
                <option value="">All U.S. States</option>
              </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="India States/Provinces"
          label-for="india-province">
          <b-form-select
            id="india-province"
            :options="indiaStateProvinceOptions"
            text-field="name"
            value-field="name"
            v-model="indiaProvince">
              <template slot="first">
                <option value="">All India States/Provinces</option>
              </template>
           </b-form-select>
         </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Sector"
          label-for="sector">
            <b-form-select
              id="sector"
              :options="sector_options"
              text-field="namr"
              value-field="name"
              v-model="sector">
                <template slot="first">
                  <option value="">All Sectors</option>
                </template>
            </b-form-select>
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          label="Type"
          label-for="type">
            <b-form-select
              id="type"
              :options="type_options"
              text-field="name"
              value-field="name"
              v-model="type">
                <template slot="first">
                  <option value="">All Types</option>
                </template>
            </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <br>
    <div class="no-results" v-if="loading">
      <b-row class="no-results-text">
        <h4 class="mr-auto ml-auto">Loading Content</h4>
      </b-row>
    </div>
    <div id="results-block">
      <div class="results-content" v-for="(program, index) in page_programs" v-if="!loading && programs.length > 0">
        <b-row class="results-row" @click="goToPartnership(program.slug)">
          <b-col md="12">
            <h2>{{ program.name }}</h2>
            <strong>Sector:</strong> {{ program.sector }}
            <br>
            <strong>Type:</strong> {{ program.type }}
            <br>
            <strong>States/Provinces:</strong>
            <span v-for="(institution, index) in program.institutions">
              {{ (index != (program.institutions.length - 1)) ? institution.state_province + ',' : institution.state_province }}
            </span>
            <br>
            <strong>Institutions:</strong>
            <span v-for="(institution, index) in program.institutions">
              {{ (index != (program.institutions.length - 1)) ? institution.name + ',' : institution.name }}
            </span>
          </b-col>
        </b-row>
        <hr :class="(index !== (page_programs.length - 1)) ? 'separator' : 'separator-lg'">
      </div>
    </div>
    <error-component v-if="!loading && programs.length <= 0">
      <template slot="title">
        <h4>No Partnerships Found! Try a different search term or adjust the filter dropdowns.</h4>
      </template>
      <template slot="message">
        <h4>Missing a Partnership? Add a Partnership by following the link below.</h4>
      </template>
    </error-component>
    <pagination
      :click-handler="changePage"
      :page="page"
      :page-count="programs.length"
      v-if="programs.length > 1">
    </pagination>
  </div>
</template>

<script>
import cleanQuery from 'clean-query'
import ErrorComponent from '@/components/ErrorComponent'
import Pagination from '@/components/Pagination'

export default {
  name: 'Partnerships',
  components: {
    ErrorComponent,
    Pagination
  },
  computed: {
    usStateProvinceOptions () {
      return this.$root.stateProvinceOptions.US
    },
    indiaStateProvinceOptions () {
      return this.$root.stateProvinceOptions.IN
    },
    typeOptions () {
      return []
    }
  },
  data: () => ({
    num_programs: 0,
    programs: [],
    page_programs: [],
    search: undefined,
    order: undefined,
    usState: undefined,
    indiaProvince: undefined,
    sector: undefined,
    type: undefined,
    page: undefined,
    order_options: [
      { value: 'asc', text: 'A-Z' },
      { value: 'desc', text: 'Z-A' }
    ],
    sector_options: [],
    type_options: [],
    loading: true
  }),
  methods: {
    changePage (page) {
      page = (this.programs[page - 1] !== undefined) ? page : 1
      this.page = page
      this.page_programs = this.programs[page - 1]

      let query = cleanQuery({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.$router.replace({
        path: (query !== '') ? '/partnerships?' + query : '/partnerships'
      })
    },
    getResults () {
      let query = cleanQuery({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.axios({
        method: 'get',
        url: (query !== '') ? '/program/search?' + query : '/program/search'
      }).then(response => {
        this.programs = response.data.programs
        this.num_programs = response.data.num_programs
        this.changePage(this.page)
        this.loading = false
      }).catch(error => {
        this.loading = false
        this.handleError(error)
      })
    },
    goToPartnership (slug) {
      this.$router.push({
        path: '/partnership/' + slug
      })
    },
    handleError (error) {
      return error
    },
    updateSelect () {
      let query = cleanQuery({
        search: this.search,
        order: this.order,
        us_state: this.usState,
        india_province: this.indiaProvince,
        sector: this.sector,
        type: this.type,
        page: this.page
      }, {
        sort: false
      })

      this.$router.replace({
        path: (query !== '') ? '/partnerships?' + query : '/partnerships'
      })

      this.getResults()
    }
  },
  watch: {
    order () {
      this.updateSelect()
    },
    usState () {
      this.updateSelect()
    },
    indiaProvince () {
      this.updateSelect()
    },
    sector () {
      this.updateSelect()
    },
    type () {
      this.updateSelect()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      const loadResults = () => {
        vm.$root.setTitle('Partnerships')
        vm.search = ((to.query.search !== undefined)) ? to.query.search : undefined
        vm.order = ((to.query.order !== undefined)) ? to.query.order : undefined
        vm.usState = ((to.query.us_state !== undefined)) ? to.query.us_state : undefined
        vm.indiaProvince = ((to.query.india_province !== undefined)) ? to.query.india_province : undefined
        vm.sector = ((to.query.sector !== undefined)) ? to.query.sector : undefined
        vm.type = ((to.query.type !== undefined)) ? to.query.type : undefined
        vm.page = ((to.query.page !== undefined)) ? Number(to.query.page) : undefined
        vm.getResults()
      }

      loadResults()
      vm.$root.$on('refreshResults', loadResults)

      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(response => {
        vm.sector_options = response.data.sort()
      })

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(response => {
        vm.type_options = response.data.sort()
      })
    })
  }
}
</script>

<style lang="scss" scoped>
  a {
    color: red;
  }

  #partnerships {
    padding-top: 2rem;
    margin-left: 5%;
    margin-right: 5%;
  }

  .no-results {
    height: 21rem;
    text-align: center;
  }

  h2 {
    font-family: 'urwgroteskregular', sans-serif;
    text-transform: capitalize;
  }

  #results-block strong {
    font-family: 'urwgroteskregular', sans-serif;
    font-weight: normal
  }

  h2:active,
  h2:focus,
  h2:hover {
    text-decoration: underline;
    color: rgb(215, 25, 32);
  }

  .separator-lg {
    margin-top: 5%;
    background-color: rgba(95, 95, 95, 0.95);
    width: 100%;
    position: relative;
  }

  .results-content {
    padding-left: 0.25%;
    padding-right: 0.25%;
  }

  .results-row {
    cursor: pointer;
    font-family: 'urwgroteskligregular', sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Partnerships.vue